import { createAction } from '@reduxjs/toolkit';
import type { RecordOf } from 'immutable';

import { getFailurePayloadCreator, getPayloadCreator } from 'app-components/flux/core/actionHelpers';

import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { AchievementEventPayload, AchievementProps } from './achievementsTypes';

const achievementsSuccessPayloadCreator = getPayloadCreator<RecordOf<QcsSyncResourcesPayload<AchievementProps>>>();
const achievementsEventPayloadCreator = getPayloadCreator<AchievementEventPayload>();

export const getAchievements = createAction('GET_ACHIEVEMENTS', getPayloadCreator());
export const getAchievementsSuccess = createAction('GET_ACHIEVEMENTS_SUCCESS', achievementsSuccessPayloadCreator);
export const getAchievementsFailure = createAction('GET_ACHIEVEMENTS_FAILURE', getFailurePayloadCreator<unknown>());

export const sendAchievementsEvent = createAction('SEND_ACHIEVEMENT_EVENT', achievementsEventPayloadCreator);
export const sendAchievementsEventSuccess = createAction('SEND_ACHIEVEMENT_EVENT_SUCCESS');
export const sendAchievementsEventFailure = createAction<unknown, 'SEND_ACHIEVEMENT_EVENT_FAILURE'>(
  'SEND_ACHIEVEMENT_EVENT_FAILURE',
);
